var R = (i, t, e) => {
  if (!t.has(i))
    throw TypeError("Cannot " + e);
};
var O = (i, t, e) => {
  if (t.has(i))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(i) : t.set(i, e);
};
var B = (i, t, e) => (R(i, t, "access private method"), e);
import { u as a, s as T } from "./static-CPcCYSrK.js";
import { n as f } from "./property-4FoNj0Pi.js";
import { e as U } from "./query-C42EGI_8.js";
import { o as u } from "./if-defined-Cd-e8xtV.js";
import { e as C } from "./class-map-Di-Oe7s4.js";
import { n as L } from "./ref-ArR26hg7.js";
import { P as S } from "./pwc-interactive-element-B6286Ky3.js";
import "./components/pwc-radio.js";
import "./components/pwc-checkbox.js";
import "./components/pwc-icon.js";
import "./components/pwc-input-surface.js";
import { w as x } from "./watch-ChG-_stu.js";
import { p as l } from "./pwcProperty-CTLG9yrF.js";
var j = Object.defineProperty, z = Object.getOwnPropertyDescriptor, o = (i, t, e, n) => {
  for (var r = n > 1 ? void 0 : n ? z(t, e) : t, p = i.length - 1, s; p >= 0; p--)
    (s = i[p]) && (r = (n ? s(t, e, r) : s(r)) || r);
  return n && r && j(t, e, r), r;
}, m, q;
class c extends S {
  constructor() {
    super(...arguments);
    O(this, m);
    this.changeEvent = "", this._requestUpdate = () => this.requestUpdate();
  }
  get checked() {
    var e;
    return this.boolType === "checkbox" ? this._checked : ((e = this.pwcRadio) == null ? void 0 : e.checked) ?? this._checked;
  }
  set checked(e) {
    this._checked = e, this.pwcRadio && (this.pwcRadio.checked = e);
  }
  handleCheckedChange() {
    this.checked = this._checked;
  }
  updateEvent(e) {
    return `pwc-radio-option:${e}:change`;
  }
  nameWatcher(e, n) {
    this.boolType !== "checkbox" && (e && document.removeEventListener(
      this.updateEvent(e),
      this._requestUpdate
    ), n && document.addEventListener(
      this.updateEvent(n),
      this._requestUpdate
    ));
  }
  disconnectedCallback() {
    this.boolType !== "checkbox" && this.name && document.removeEventListener(
      this.updateEvent(this.name),
      this._requestUpdate
    ), super.disconnectedCallback();
  }
  render() {
    const {
      boolType: e,
      orientation: n,
      name: r,
      value: p,
      focused: s,
      checked: $,
      disabled: d,
      icon: h,
      logomark: b,
      label: w,
      description: _
    } = this, k = n === "column" && (h || b) ? "column" : "row", v = () => a`<pwc-icon icon=${u(h)} size="32"></pwc-icon>`, y = () => a`<pwc-logomark
        logomark=${u(b)}
        size="32"
      ></pwc-logomark>`, g = T(`pwc-${e}`), P = (E = !0) => a`
      <${g}
        name=${u(r)}
        value=${u(p)}
        ?disabled=${d}
        ?checked=${$}
        ?labelled=${E}
        tab-index=${-1}
      >
        ${E ? a`
                ${h ? v() : b ? y() : null}
                <div class="PwcBoolOption__text">
                  <span>${w}</span>
                  ${_ ? a`<small>${_}</small>` : null}
                </div>
              ` : null}
      </${g}>
    `;
    return a`
      <div class="PwcBoolOption">
        <pwc-input-surface
          ?focused=${s}
          ?checked=${$}
          ?disabled=${d}
          class=${C({
      PwcBoolOption__inputSurface: !0,
      [`PwcBoolOption__inputSurface--${k}`]: !0
    })}
        >
          <button
            ${L(this.interactiveElementRef)}
            class=${C({
      PwcBoolOption__button: !0,
      [`PwcBoolOption__button--${k}`]: !0,
      "PwcBoolOption__button--checked": $,
      "PwcBoolOption__button--disabled": d
    })}
            ?disabled=${d}
            type="button"
            @click=${B(this, m, q)}
          >
            ${k === "row" ? P() : a`
                  ${h ? v() : y()}
                  <label>${w}</label>
                  ${P(!1)}
                `}
          </button>
        </pwc-input-surface>
      </div>
    `;
  }
}
m = new WeakSet(), q = function() {
  if (this.boolType === "checkbox") {
    this.checked = !this.checked, this.emit("p-change", { detail: this.checked });
    return;
  }
  this.checked = !0, this.emit("p-change", { detail: !0 }), this.name && document.dispatchEvent(new CustomEvent(this.updateEvent(this.name)));
};
o([
  U("pwc-radio")
], c.prototype, "pwcRadio", 2);
o([
  l({ default: "row" })
], c.prototype, "orientation", 2);
o([
  f()
], c.prototype, "icon", 2);
o([
  f()
], c.prototype, "logomark", 2);
o([
  l({ type: String, default: "" })
], c.prototype, "label", 2);
o([
  l({ type: String, default: "" })
], c.prototype, "description", 2);
o([
  f()
], c.prototype, "name", 2);
o([
  f()
], c.prototype, "value", 2);
o([
  l({ type: Boolean, reflect: !0, default: !1 })
], c.prototype, "disabled", 2);
o([
  l({ type: Boolean, attribute: "checked", default: !1 })
], c.prototype, "_checked", 2);
o([
  x("_checked")
], c.prototype, "handleCheckedChange", 1);
o([
  x("name")
], c.prototype, "nameWatcher", 1);
export {
  c as P
};
